/**
 * Show More Text Button Component
 * Reusable inline text button for expanding/collapsing content
 * Matches design system specifications:
 * - color: #1C1917 (typography primary)
 * - font-family: Gantari (primary font)
 * - font-size: 14px (sm)
 * - font-weight: 600 (semibold)
 * - line-height: normal
 */

import React from 'react';
import {
  typographyColors,
  spacing,
  typography,
  fontPrimary,
} from '@/design-system/utils';

export interface ShowMoreTextButtonProps {
  isExpanded?: boolean;
  onClick?: () => void;
  className?: string;
  style?: React.CSSProperties;
}

export const ShowMoreTextButton: React.FC<ShowMoreTextButtonProps> = ({
  isExpanded = false,
  onClick,
  className,
  style,
}) => {
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation(); // Prevent parent click handlers from firing
    onClick?.();
  };

  return (
    <button
      onClick={handleClick}
      className={className}
      style={{
        background: 'none',
        border: 'none',
        padding: 0,
        cursor: 'pointer',
        fontFamily: fontPrimary,
        fontSize: typography.size.sm, // 14px
        fontWeight: typography.weight.semibold, // 600
        color: typographyColors.primary, // #1C1917
        lineHeight: 'normal',
        textAlign: 'left',
        alignSelf: 'flex-start',
        marginTop: spacing[1],
        ...style,
      }}
    >
      {isExpanded ? 'Show Less' : 'Show More'}
    </button>
  );
};
